import { Coupon } from "../types";
import { patientApi } from "./patientApi";

export const couponsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    validateCoupon: builder.query<
      Coupon | null,
      { couponCode: string; productSlug: string }
    >({
      query: (params) => ({
        url: `/api/coupons/validate`,
        method: "GET",
        params,
      }),
    }),
  }),
});

export const { useValidateCouponQuery, useLazyValidateCouponQuery } =
  couponsApi;
